import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { format } from 'date-fns';

export const PoslanePorukeDataTable = (props) => {
  const [poruke, setPoruke] = useState();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  useEffect(() => {
    setPoruke(props.data);
  }, [props.data]);

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };


  const vrijemeSlanjaColumn = (poruka) => {
    if ( poruka.vrijeme_slanja !== null )
      return format(new Date(poruka.vrijeme_slanja), 'dd.MM.yyyy. HH:mm');
    else 
      return "";
  }

  
  return (
    <div className="centerText">   
      <DataTable
        value={poruke}
        stripedRows
        responsiveLayout="scroll"
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
      >
      <Column
        field="predavac"
        header="Primatelj"
        className="table-column-grade"
      ></Column>
      <Column
        field="naslov"
        header="Naslov"
        className="table-column-course"
      ></Column>
      <Column
        field="tekst_poruke"
        header="Sadržaj"
        className="table-column-default"
      ></Column>
      <Column
          field="vrijeme_slanja"
          header="Poslano"
          body = { vrijemeSlanjaColumn }
          className="table-column-date"
        ></Column>
      </DataTable>
    </div>
  );
};

export default PoslanePorukeDataTable;
